import {Component, OnInit} from '@angular/core';
import {OfflineOptions, ControlAnchor, NavigationControlType} from 'angular2-baidu-map';
import { MainService } from '../../service/main.service';

@Component({
  selector: 'map-presentation',
  templateUrl: './baidumap.component.html',
  styleUrls: ['./baidumap.component.styl'],
})
export class BaiduComponent implements OnInit {

  opts:any;
  offlineOpts:OfflineOptions;
  longitude: number;
  latitude: number;
  /*
    信息
  */
  list: Array<object>;
  //微信二维码
  QRcode: string;
  constructor(public mainService: MainService){}
  ngOnInit() {
    this.mainService.getCommentData()
      .subscribe(
        data=>{          
          this.longitude = data.longitude;
          this.latitude = data.latitude;
           this.opts = {
            // 地图中心坐标
            center: {
              longitude: this.longitude,
              latitude: this.latitude
            },
            zoom: 20,
            // 地图上的坐标23.12468  113.3612
            markers: [{
              longitude: this.longitude,
              latitude: this.latitude,
              // title: '广州极云网络',
              // content: '百脑汇科技大厦B座2911',
              autoDisplayInfoWindow: true
            }],
            geolocationCtrl: {
              anchor: ControlAnchor.BMAP_ANCHOR_BOTTOM_RIGHT
            },
            scaleCtrl: {
              anchor: ControlAnchor.BMAP_ANCHOR_BOTTOM_LEFT
            },
            overviewCtrl: {
              isOpen: true
            },
            navCtrl: {
              type: NavigationControlType.BMAP_NAVIGATION_CONTROL_LARGE
            }
          };
          this.list = data.contact_list;
          this.QRcode = data.weixin;
        },
        error=>{
          console.log(error)
        }
      )
    // 配置地图, 参考百度地图api

    this.offlineOpts = {
      retryInterval: 5000,
      txt: '没有网络'
    };
  }

  // 刚加载加载地图信息
  loadMap(e:any) {
    // console.log(e);
  }

  // 单机地图坐标, 打印信息
  clickMarker(marker:any) {
    // console.log(marker);
  }

}


// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/comment/baidumap/baidumap.component.ts